import { render, staticRenderFns } from "./MedRecordPreview.vue?vue&type=template&id=2c9bf7d0"
import script from "./MedRecordPreview.vue?vue&type=script&lang=js"
export * from "./MedRecordPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports